import React from 'react';
import { Provider } from 'react-redux';
import store from 'pages/store/index';
import { createReactRenderer } from 'helpers/react-renderer';
import ConnectedVendorsAutocomplete from 'pages/containers/VendorsAutocomplete/index';

const StoreWrappedVendorsAutocomplete = props => (
  <Provider store={store}>
    <ConnectedVendorsAutocomplete {...props} />
  </Provider>
);

export default StoreWrappedVendorsAutocomplete;

const RenderedComponent = createReactRenderer({
  component: StoreWrappedVendorsAutocomplete,
  selector: '[data-react-root="VendorsAutocomplete"]',
});

history.onChangeState(
  {
    name: [
      'item.views.item',
      'item.views.register_item',
      'item.views.quick_add',
      'item.views.register_workorder_item',
      'purchase.views.purchase',
      'item_group.views.item_group',
      'transfer.views.transfer',
      'vendor_return.views.vendor_return',
      'purchase.views.master_order',
    ],
    id: undefined,
  },
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
